// Messages for portal/Conversations (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'portal.conversations.head': 'Conversations — Portal',
  'portal.conversations.title': 'Conversations',
  'portal.conversations.desc': 'All your shipment chats in one place',
  'portal.conversations.empty_list': 'No conversations yet.',
  'portal.conversations.load_more': 'Load more conversations',
  'portal.conversations.select_prompt': 'Select a conversation to read and reply.',
  'portal.conversations.open_shipment': 'Open shipment',
  'portal.conversations.thread_empty': 'No messages yet — start the conversation.',
  'portal.conversations.reply_aria': 'Reply',
  'portal.conversations.reply_placeholder': 'Reply…',
  'portal.conversations.visibility': 'Your team & Geo4Logistics',
  'portal.conversations.send': 'Send',
  'portal.conversations.rail.status': 'Status',
  'portal.conversations.rail.carrier': 'Carrier',
  'portal.conversations.rail.route': 'Route',
  'portal.conversations.rail.eta': 'ETA',
  'portal.conversations.rail.tracking': 'Tracking',
  'portal.conversations.ago.now': 'now',
  'portal.conversations.ago.minutes': '{n}m',
  'portal.conversations.ago.hours': '{n}h',
  'portal.conversations.ago.days': '{n}d',
}

export const zhTW = {
  'portal.conversations.head': '對話 — 客戶入口',
  'portal.conversations.title': '對話',
  'portal.conversations.desc': '集中管理您所有貨件的對話',
  'portal.conversations.empty_list': '尚無對話。',
  'portal.conversations.load_more': '載入更多對話',
  'portal.conversations.select_prompt': '選擇一則對話以閱讀並回覆。',
  'portal.conversations.open_shipment': '開啟貨件',
  'portal.conversations.thread_empty': '尚無訊息 — 開始對話。',
  'portal.conversations.reply_aria': '回覆',
  'portal.conversations.reply_placeholder': '回覆…',
  'portal.conversations.visibility': '您的團隊與 Geo4Logistics',
  'portal.conversations.send': '傳送',
  'portal.conversations.rail.status': '狀態',
  'portal.conversations.rail.carrier': '承運商',
  'portal.conversations.rail.route': '路線',
  'portal.conversations.rail.eta': '預計到達',
  'portal.conversations.rail.tracking': '追蹤',
  'portal.conversations.ago.now': '剛剛',
  'portal.conversations.ago.minutes': '{n} 分鐘前',
  'portal.conversations.ago.hours': '{n} 小時前',
  'portal.conversations.ago.days': '{n} 天前',
}
